import { AccrediblePageMeta } from '@accredible-frontend-v2/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  SpotlightProfile,
  SpotlightProfilesFilters,
} from '../../../../core/models/spotlight-profiles.model';

export const SpotlightProfilesActions = createActionGroup({
  source: 'SpotlightProfiles',
  events: {
    loadPlaceDetails: props<{
      directoryId: number;
      placeId: string;
      filters: SpotlightProfilesFilters;
    }>(),
    loadPlaceDetailsSuccess: props<{
      directoryId: number;
      filters: SpotlightProfilesFilters;
    }>(),
    loadPlaceDetailsFailure: props<{ error: any }>(),

    loadSpotlightProfiles: props<{
      directoryId: number;
      filters: SpotlightProfilesFilters;
    }>(),
    loadSpotlightProfilesSuccess: props<{
      meta: AccrediblePageMeta;
      profiles: SpotlightProfile[];
    }>(),
    loadSpotlightProfilesFailure: props<{ error: any }>(),

    clearFilters: emptyProps(),
  },
});
